ACC.checkoutsteps = {

    _autoload: [
        "permeateLinks"
    ],

    permeateLinks: function () {

        $(document).on("click", ".js-checkout-step", function (e) {
            if (!$(this).hasClass('active')) {
                e.preventDefault();
                $(this).addClass('active')
                var checkoutStepsElm = $(this).closest('.checkout-steps');
                var stepBlockElm = $(this).closest('.step-block');
                var clickedStepIndex = checkoutStepsElm.children().index(stepBlockElm);
                var activatedStepIndex = checkoutStepsElm.children('.active').index();
                console.log("an other Click");
                if (clickedStepIndex <= activatedStepIndex) {
                    window.location = $(this).attr("href")
                } else {
                    $('.amds-checkout-form').submit();
                }
            } else {
                return false;
            }
        })

        /////////////////////////////// choose the delivery date///////////////////////////////////////////

        $(document).on('click', '.delivery-date-link-js', function () {

            let _this = $(this),
                closingDays = _this.data('closing-days'),
                deliveryDate = _this.attr('data-delivery-date'),
                defaultDeliveryDate = _this.attr('data-default-delivery-date'),
                year= deliveryDate.split("'")[1].split("/")[2],
                month = deliveryDate.split("'")[1].split("/")[1] ,
                day= deliveryDate.split("'")[1].split("/")[0];

            localStorage.setItem('selectedDeliveryMethod', _this.attr('data-id'));

            $("#chooseDeliveryDate #date").datepicker({
                numberOfMonths: 2,
                changeYear: false,
                changeMonth: false,
                selected: deliveryDate.split("'")[1].split("/").reverse().join("/"),
                stepMonths: 0,
                minDate: defaultDeliveryDate,
                beforeShowDay: function (date) {
                    var formattedDate = $.datepicker.formatDate('dd/mm/yy', date),
                        noWeekends = date.getDay() !== 0 && date.getDay() !== 6;

                    if (deliveryDate.length > 0) {
                        $('.selectedDeliveryDate').val(deliveryDate.split("'")[1]);
                    }

                    return deliveryDate.indexOf(formattedDate) !== -1 ? [true, 'booked'] : [closingDays.indexOf(formattedDate) === -1 && noWeekends];
                },
                onSelect: function (date, datepicker) {
                    deliveryDate = [];
                    $('.selectedDeliveryDate').val(date);

                    setTimeout(function() {
                        $('.ui-state-hover').removeClass('ui-state-hover');
                    }, 5);
                },
                dateFormat: 'dd/mm/yy',
                duration: 'fast',
                dayNamesMin: dayNamesMin,
                dayNamesShort: $.datepicker.regional["fr"].dayNamesShort,
                dayNames: $.datepicker.regional["fr"].dayNames,
                monthNamesShort: $.datepicker.regional["fr"].monthNamesShort,
                monthNames: monthNames,
                todayHighlight: false,
            });

            // Remove Attr title
            $("#chooseDeliveryDate .ui-datepicker-calendar span").removeAttr("title");

            $('#chooseDeliveryDate').modal({
                keyboard: false
            }).on('shown.bs.modal', function () {
                $('.ui-datepicker-current-day').find('a').removeClass('ui-state-active ui-state-hover');
            }).on("hidden.bs.modal", function () {
                $("#chooseDeliveryDate #date").datepicker("destroy");
            });

        }).on('click', '#selectedDate', async function (e) {
            e.preventDefault();

            var deliveryDate = $('.selectedDeliveryDate').val(),
                deliveryModeCode = $('input[name="delivery_method"]:checked').val();

            await fetch(`${ACC.config.setDeliveryDate}?deliveryDate=${deliveryDate}`)
                .then((response) => response.json())
                .then((json) => {
                    let _ = localStorage.getItem("selectedDeliveryMethod");
                    $(`.delivery-date span.deliveryDate.${_}`).html(json.deliveryDate);
                    $(`.delivery-date-link.${_}`).attr('data-delivery-date', `['${deliveryDate}']`);
                });

            $('#chooseDeliveryDate').modal('hide');
        });

        $(document).on("change", "input[name=delivery_method]", function (e) {
            $('.selectedDeliveryDate').val('');
            $('.delivery-name').each(function() {
                $(this).find('.delivery-date span').html($(this).find('.delivery-date-link').attr('data-initial-delivery-date'));
                $(this).find('.delivery-date a').attr('data-delivery-date', "['" + $(this).find('.delivery-date a').attr('data-default-delivery-date') + "']");
            });
        })
    }
};
